import { PlainMessage } from "@bufbuild/protobuf";
import { Price } from "@egocentric-systems/ts-apis/booking_gateway/v1/events_pb";
import { Money } from "@egocentric-systems/ts-apis/types/v1/money_pb";
import { moneyToNumber } from "~/lib/utils";

// sortPricesByValue: sorts prices in ascending order based on their value
export function sortPricesByValue(
  prices?: Array<PlainMessage<Price>>,
): Array<PlainMessage<Price>> | undefined {
  return prices?.toSorted((a, b) => {
    const valueA = moneyToNumber(a.value);
    const valueB = moneyToNumber(b.value);

    return valueA - valueB;
  });
}

// getMaxPriceValue: Get the maximum price value from the sorted prices
export function getMaxPriceValue(prices?: Array<PlainMessage<Price>>): number {
  const sortedPrices = sortPricesByValue(prices);
  const maxPrice = sortedPrices?.at(Number(prices?.length) - 1);

  return moneyToNumber(maxPrice?.value);
}

// getMinPriceValue: Get the maximum price value from the sorted prices
export function getMinPriceValue(prices?: Array<PlainMessage<Price>>): number {
  const sortedPrices = sortPricesByValue(prices);
  const minPrice = sortedPrices?.at(0);

  return moneyToNumber(minPrice?.value);
}

// isPriceWithinRange:  Check if the maximum price falls within the specified range
export function isPriceWithinRange(
  maxPrice: number,
  min: string | null,
  max: string | null,
): boolean {
  return (
    (min === null && max === null) ||
    ((min ? Number(min) : 0) <= maxPrice &&
      (max ? Number(max) : Infinity) >= maxPrice)
  );
}
